function upsertMeta(
  selector: string,
  attribute: "name" | "property",
  attributeValue: string,
  content: string
): void {
  let element = document.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, attributeValue);
    document.head.append(element);
  }
  element.setAttribute("content", content);
}

export function setPageMetadata(title: string, description: string): void {
  document.title = title;
  upsertMeta('meta[name="description"]', "name", "description", description);
  upsertMeta('meta[property="og:title"]', "property", "og:title", title);
  upsertMeta(
    'meta[property="og:description"]',
    "property",
    "og:description",
    description
  );
}
